import { Helmet } from 'react-helmet'
import 'swiper/css/bundle'

import { GlobalStyle } from 'styles/global'
import { Home } from 'containers/home'
import { MenuContextProvider } from 'context/menu-context'
import { DataProvider } from 'context/data-context'

const PageTitle = () => {
  return (
    <Helmet>
      <title>Istorii despre ceea ce contează</title>
    </Helmet>
  )
}

function App() {
  return (
    <MenuContextProvider>
      <DataProvider>
        <PageTitle />
        <GlobalStyle />
        <Home />
      </DataProvider>
    </MenuContextProvider>
  )
}

export default App
